import { signal } from "@preact/signals-react";

import TableCell from "componentsv2/table/TableCell";
import poolCell from "./poolCell";
import toolsCell from "./toolsCell";

function factoryCell({
  record,
  field,
  parentRec,
  fieldName,
  key,
  model,
  onChange,
  onClickCell,
  triggerAction,
  layout,
  tableId,
}) {
  const { name } = field;
  const isInvisible = toolsCell.getInvisible(field, record.value || record);

  const align = toolsCell.getAlign(field);
  const value = toolsCell.getValue(field, record);
  const readOnly = toolsCell.getReadOnly(field, record, parentRec);
  const data = signal(value);
  let color;
  const attrs = {
    field,
    model,
    record: record,
    fieldName,
    parentRec,
    onChange,
    layout,
    triggerAction,
    readOnly,
    isInvisible,
    tableId,
  };

  const _type = field.widget ?? field.type;

  const ComponentCell = poolCell[_type];
  if (!ComponentCell) {
    return null;
  }
  const componentCell = <ComponentCell key={key} {...attrs} data={data} />;

  return (
    <TableCell
      key={name}
      selectable={field.selectable}
      record={record}
      field={name}
      align={align}
      onClick={onClickCell}
      color={color}
    >
      {isInvisible ? null : componentCell}
    </TableCell>
  );
}

export default factoryCell;
